import React, { memo, useCallback } from 'react'
import { Facet } from 'transfix-ui/components/Facet'
import { makeStyles } from 'transfix-ui/core/styles'
import { IMissingInfoFilters } from '../../types'
import { addMissingInfoFilter, removeMissingInfoFilter } from './utils'

const useMissingInfoFiltersStyles = makeStyles(theme => ({
  root: {
    overflowX: 'scroll',

    [theme.breakpoints.up('md')]: {
      overflowX: 'visible',
    },
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: `0 ${theme.spacing(2)}`,

    [theme.breakpoints.up('md')]: {
      padding: `0`,
    },

    '& > div:last-of-type': {
      padding: `0 ${theme.spacing(2)} 0 0`,

      [theme.breakpoints.up('md')]: {
        padding: `0`,
      },
    },
  },
}))

export const MISSING_INFO_FILTERS = [
  {
    label: 'Any',
    value: IMissingInfoFilters.any,
  },
  {
    label: 'Driver',
    value: IMissingInfoFilters.driver,
  },
  {
    label: 'ETA',
    value: IMissingInfoFilters.eta,
  },
  {
    label: 'Truck',
    value: IMissingInfoFilters.truck,
  },
  {
    label: 'VIN',
    value: IMissingInfoFilters.vin,
  },
  {
    label: 'Trailer',
    value: IMissingInfoFilters.trailer,
  },
  {
    label: 'Documents',
    value: IMissingInfoFilters.documents,
  },
]

export interface IMissingInfoFiltersProps {
  selectedFilters: IMissingInfoFilters[]
  onFilterChange: (filters: IMissingInfoFilters[]) => void
}

const MissingInfoFilters = memo<IMissingInfoFiltersProps>(({ onFilterChange, selectedFilters }) => {
  const classes = useMissingInfoFiltersStyles()

  const clickFilterHandler = useCallback(
    (selected: boolean, id?: string) => {
      const filterValue: IMissingInfoFilters = id as IMissingInfoFilters
      if (selected) {
        onFilterChange(addMissingInfoFilter(selectedFilters, filterValue))
      } else {
        onFilterChange(removeMissingInfoFilter(selectedFilters, filterValue))
      }
    },
    [onFilterChange, selectedFilters]
  )

  return (
    <div className={classes.root}>
      <div className={classes.filters}>
        {MISSING_INFO_FILTERS.map(({ label, value }) => (
          <Facet
            key={value}
            label={label}
            id={value}
            dataTest={`missing-info-${value}`}
            selected={selectedFilters.includes(value)}
            onClick={clickFilterHandler}
          />
        ))}
      </div>
    </div>
  )
})

export default MissingInfoFilters
